<template>
  <div class="flow_container">
    <div class="dataCenter">
      <div class="header">
        <div class="left"><i class="el-icon-success"></i>作品状态正常</div>
        <div class="left"><i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="show_data_box">
        <div class="title">流量</div>
        <div class="flow_list">
          <div :class="['list_item',{'active_list_item':item.id==activeFlowId}]" v-for="item in FlowData" :key="item.id" @click="changeFlowId(item)">
            <div class="name">{{ item.name }}</div>
            <div class="value">{{video_id==1? item.value1 :item.value2}}</div>
          </div>
        </div>
        <div class="button_box">
          <div class="left_button">
            <span :class="[{'active_span':activeTypeId==1}]">新增</span>
            <span :class="[{'active_span':activeTypeId==2}]">累计</span>
            <span :class="[{'active_span':activeTypeId2==1}]">每小时</span>
            <span :class="[{'active_span':activeTypeId2==2}]">每天</span>
          </div>
          <div class="right_button">设置观测 <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="flowEachrts" ref="flowEachartsRef"></div>
        <div class="tip">
          <div class="left">
            <img src="../../assets/img/image/dou+.png" alt="">
            投放DOU+可获得更多播放量和互动
          </div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </div>
    <!-- 粉丝的 -->
    <div class="dataCenter">
      <div class="show_data_box">
        <div class="title">粉丝</div>
        <div class="flow_list">
          <div :class="['list_item',{'active_list_item':item.id==activeFansId}]" v-for="item in FansData" :key="item.id" @click="changeFansId(item)">
            <div class="name">{{ item.name }}</div>
            <div class="value">{{video_id==1? item.value1 :item.value2}}</div>
          </div>
        </div>
        <div class="button_box">
          <div class="left_button">
            <span :class="[{'active_span':activeTypeId==1}]">新增</span>
            <span :class="[{'active_span':activeTypeId==2}]">累计</span>
            <span :class="[{'active_span':activeTypeId2==1}]">每小时</span>
            <span :class="[{'active_span':activeTypeId2==2}]">每天</span>
          </div>
          <div class="right_button">设置观测 <i class="el-icon-arrow-right"></i></div>
        </div>
        <div class="flowEachrts" ref="fansEachartsRef"></div>
      </div>
    </div>
    <div class="view_more">
      查看更多作品数据<i class="el-icon-arrow-right"></i>
    </div>

  </div>
</template>
  
  <script>
import {
  flowData,
  FanWorkData,
  AudienceAnalysisData,
} from "./js/Operatingdata";
export default {
  data() {
    return {
      FlowData: [
        {
          name: "播放量",
          id: 1,
          value1: "45.7万",
          value2: "3.7万",
          unit: "",
        },
        {
          name: "点赞量",
          id: 2,
          value1: "614",
          value2: "205",
          unit: "",
        },
        {
          name: "评论量",
          id: 3,
          value1: "34",
          value2: "4",
          unit: "",
        },
        {
          name: "分享量",
          id: 4,
          value1: "263",
          value2: "100",
          unit: "",
        },
        {
          name: "收藏量",
          id: 5,
          value1: "91",
          value2: "20",
          unit: "",
        },
        {
          name: "弹幕量",
          id: 6,
          value1: "0",
          value2: "0",
          unit: "",
        },
        {
          name: "完播率",
          id: 7,
          value1: "22.09%",
          value2: "11.86%",
          unit: "%",
        },
        {
          name: "2s跳出率",
          id: 8,
          value1: "36.49%",
          value2: "35.94%",
          unit: "%",
        },
      ],
      flowEchartsData: [],
      FansData: [
        {
          name: "涨粉量",
          id: 1,
          value1: "34",
          value2: "30",
          unit: "",
        },
        {
          name: "脱粉量",
          id: 2,
          value1: "14",
          value2: "2",
          unit: "",
        },
        {
          name: "粉丝播放占比",
          id: 3,
          value1: "0.11%",
          value2: "1.39%",
          unit: "%",
        },
      ],
      fansEchatsData: [],
      audienceAnalysisData: [],
      activeFlowId: 1,
      activeTypeId: 1,
      activeTypeId2: 2,
      video_id: 1,
      activeFansId: 1,
    };
  },
  mounted() {
    this.video_id = this.$route.query.video_id;
    this.flowEchartsData = flowData[this.video_id - 1].flowData;
    let obj1 = this.flowEchartsData.find(
      (item) => item.id == this.activeFlowId
    );
    console.log(" this.flowEchartsData", this.fansEchatsData);
    console.log("obj1.data", obj1.data);
    this.$nextTick(() => {
      this.getFlowEcharts(obj1.data, 1);
    });
    this.fansEchatsData = FanWorkData[this.video_id - 1].fansData;
    let obj2 = this.fansEchatsData.find((item) => item.id == this.activeFansId);
    console.log(" this.fansEchatsData", this.fansEchatsData);
    console.log("obj2.data", obj2.data);

    this.$nextTick(() => {
      this.getFlowEcharts(obj2.data, 2);
    });
  },

  methods: {
    changeFlowId(item) {
      this.activeFlowId = item.id;
      let obj1 = this.flowEchartsData.find(
        (item) => item.id == this.activeFlowId
      );
      this.getFlowEcharts(obj1.data, 1);
    },
    changeFansId(item) {
      this.activeFansId = item.id;
      let obj1 = this.fansEchatsData.find(
        (item) => item.id == this.activeFansId
      );
      this.getFlowEcharts(obj1.data, 2);
    },
    getFlowEcharts(y, type) {
      const today = new Date();
      // 生成近七日的日期数组，按从小到大排列
      const dates = [];
      for (let i = 6; i >= 0; i--) {
        const date = new Date(today);
        date.setDate(today.getDate() - i);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        dates.push(`${month}-${day}`);
        var chart = null;
        let index = 1;
        let arrData = [];
        if (type == 1) {
          chart = this.$echarts.init(this.$refs.flowEachartsRef);
          index = this.activeFlowId;
          arrData = this.FlowData;
        } else if (type == 2) {
          chart = this.$echarts.init(this.$refs.fansEachartsRef);
          index = this.activeFansId;
          arrData = this.FansData;
        }
        let option = {
          grid: {
            left: 42,
          },
          xAxis: {
            type: "category",
            data: dates,
            boundaryGap: false,
            splitLine: {
              show: false, // 隐藏 x 轴的分隔线
            },
            axisTick: {
              show: false, // 隐藏 x 轴的刻度线（即坐标文字旁的小竖线）
            },
            axisLabel: {
              show: true, // 保留 x 轴的标签,
              color: "#999999",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
          },
          tooltip: {
            trigger: "axis",
            backgroundColor: "rgba(255,255,255,1)",
            formatter: (params) => {
              let res = `<div style="color:#666;box-shadow: 0 5px 10px 1px rgba(32, 32, 32, 0.05);padding:10px;border-radius:4px">
              <div >${params[0].axisValueLabel}<div>
                <div style="display: flex;align-items: center;margin-top: 6px;font-size:14px;"><span style="width: 10px;height: 10px;border-radius: 10px;background: #577cf7;margin-right: 5px;"></span><span style="margin-right: 10px;">${
                  arrData[index - 1].name
                }</span><span>${params[0].value}${
                arrData[index - 1].unit
              }</span><div>
              <div>`;
              return res;
            },
          },
          yAxis: {
            type: "value",
            axisLine: {
              show: false,
            },
            splitLine: {
              show: true, // 隐藏 y 轴的分隔线
              lineStyle: {
                color: "#F2F2F4", // 设置轴线颜色为红色
                type: "dashed", // 设置轴线为虚线
              },
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              formatter: function (value) {
                if (value >= 10000) {
                  return (value / 10000).toFixed(1) + "w";
                } else if (value >= 1000) {
                  return (value / 1000).toFixed(1) + "k";
                }
                return value + arrData[index - 1].unit;
              },
            },
            min: 0,
            max:
            ((index == 6) && type == 1 && this.video_id == 1) ||
              ((index == 1 || index == 2) && type == 2 && this.video_id == 2) ||
              (type == 1 &&
                this.video_id == 2 &&
                (index == 2 ||
                  index == 6 ||
                  index == 3 ||
                  index == 5 ||
                  index == 4))
                ? 5
                : void 0,
          },
          // dataZoom: {
          //   type: "slider",
          //   start: 0,
          //   end: 60,
          //   // 固定手柄大小
          //   handleSize: 0,
          //   // 禁止缩放
          //   zoomLock: true,
          //   // 背景颜色
          //   backgroundColor: "rgba(220, 220, 220, 0.8)",
          //   // 选中区域的背景颜色
          //   dataBackground: {
          //     lineStyle: {
          //       color: "rgba(160, 160, 160, 0.8)",
          //     },
          //     areaStyle: {
          //       color: "rgba(160, 160, 160, 0.4)",
          //     },
          //   },
          //   // 选中区域的颜色
          //   fillerColor: "rgba(87, 124, 247, 0.8)",
          //   // 边框颜色
          //   borderColor: "rgba(87, 124, 247, 1)",
          // },
          series: [
            {
              data: y,
              type: "line",
              smooth: true,
              color: "#577cf7",
              areaStyle: {
                // 设置渐变色
                color: {
                  type: "linear",
                  x: 0, // 渐变色的起始点 x 轴位置
                  y: 0, // 渐变色的起始点 y 轴位置
                  x2: 0, // 渐变色的结束点 x 轴位置
                  y2: 1, // 渐变色的结束点 y 轴位置
                  colorStops: [
                    { offset: 0, color: "rgba(0, 0, 255, 0.2)" }, // 起始颜色
                    { offset: 1, color: "rgba(0, 0, 255, 0)" }, // 结束颜色
                  ],
                  global: false, // 使用局部渐变色
                },
                origin: "start",
              },
            },
          ],
        };
        chart.setOption(option);
        window.onresize = () => {
          // 基础数据
          chart.resize();
        };
      }
    },
  },
};
</script>
  
  <style scoped lang="scss">
.flow_container {
  .dataCenter {
    width: 100%;
    background: #fff;
    border-radius: 4px;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      height: 40px;
      align-items: center;

      .left {
        font-weight: 600;
        .el-icon-success {
          margin-right: 5px;
          color: #59be65;
        }
      }
    }
    .show_data_box {
      padding: 20px 10px;
      padding-top: 0px;
      box-sizing: border-box;
      .title {
        font-size: 16px;
        font-weight: 600;
      }
      .flow_list {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin-top: 10px;
        .list_item {
          width: 31%;
          background: #f7f7f8;
          padding: 6px;
          box-sizing: border-box;
          border-radius: 4px;
          border: 1px solid transparent;
          cursor: pointer;
          .name {
            font-size: 13px;
            color: #999;
          }
          .value {
            font-size: 14px;
            color: 333;
            font-weight: 600;
            margin-top: 5px;
          }
        }
        .active_list_item {
          background: #f5f7fe;
          border: 1px solid #95acf9;
        }
      }
      .button_box {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left_button {
          span {
            background: #f3f3f3;
            padding: 3px 6px;
            margin-right: 5px;
            border-radius: 4px;
            color: #999;
            cursor: pointer;
          }
          .active_span {
            color: #333;
          }
        }
      }
      .flowEachrts {
        width: 100%;
        height: 300px;
      }
      .tip {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 40px;
        border-top: 1px solid #fdfdfd;
        .left {
          display: flex;
          align-items: center;
          img {
            width: 30px;
            margin-right: 2px;
          }
        }
      }
    }
  }
  .view_more {
    margin: 20px 0;
    width: 100%;
    background: #fff;
    border-radius: 4px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 15px;
    .el-icon-arrow-right {
      color: #333;
      font-weight: 600;
      font-size: 18px;
      margin-top: 2px;
    }
  }
}
</style>
  